import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import { motion, useAnimation } from "framer-motion"
import { Swiper, SwiperSlide } from "swiper/react"

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectFade } from "swiper"

// Import Swiper styles
import "swiper/swiper.scss"
import "swiper/components/navigation/navigation.scss"
import "swiper/components/pagination/pagination.scss"
import 'swiper/components/effect-fade/effect-fade.scss';


SwiperCore.use([Navigation, A11y, EffectFade])

const GallerySlider = ({ slice, gallery }) => {
  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.5,
  })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  const group = {
    hidden: {
      // opacity: 0,
      // y: 50,
    },
    visible: {
      // opacity: 1,
      // y: 0,
      transition: {
        // delay: 1,
        // duration: 0.8,
        staggerChildren: 0.1,
        delayChildren: 0,
      },
    },
  }

  const child = {
    hidden: {
      opacity: 0,
      // y: 50,
    },
    visible: {
      opacity: 1,
      // y: 0,
      transition: {
        duration: 0.8,
      },
    },
  }

  return (
    <motion.div
      ref={ref}
      animate={controls}
      transition={{
        type: "tween",
        ease: "easeIn",
        delay: 0.25,
      }}
      initial="hidden"
      // className="container section team"
      variants={{
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
          },
        },
        hidden: {
          opacity: 0,
          y: 50,
        },
      }}
    >
      <div className="section gallery-slider container">
        <header class="section-title">
          <h2 class="section-title__heading">{slice.primary.title.text}</h2>
          {/* <p className="section-title__blurb">Awesome blurb here!</p> */}
        </header>

        <motion.div
          ref={ref}
          animate={controls}
          transition={{
            type: "tween",
            ease: "easeIn",
          }}
          initial="hidden"
          variants={group}
        >
          <Swiper
            // effect="fade"
            className="gallery-slider__swiper"
            spaceBetween={50}
            slidesPerView={1}
            // slidesPerView={1.8}
            spaceBetween={12}
            navigation
            // pagination={{
            //   clickable: true,
            //   renderBullet: (index, className) => {
            //     return (
            //       '<span class="' +
            //       className +
            //       '">' +
            //       '<span class="inner">' +
            //       (index + 1) +
            //       "</span>" +
            //       "</span>"
            //     )
            //   },
            // }}
            // scrollbar={{ draggable: true }}
            centeredSlides={true}
            loop={true}
            watchSlidesVisibility={true}
            onSwiper={swiper => console.log(swiper)}
            onSlideChange={() => console.log("slide change")}
            breakpoints={{
              768: {
                slidesPerView: 1.5,
              },
            }}
          >
            {gallery.data.group.map(g => (
              <SwiperSlide>
                <motion.div
                  transition={{
                    type: "tween",
                    ease: "easeIn",
                  }}
                  className="video-title"
                  variants={child}
                >
                  {/* <img src={g.image.url} alt="" /> */}

                  <picture>
                    <source
                      srcSet={g.image.thumbnails.Mobile.url}
                      // srcSet={g.image.fluid.srcSet.mobile}
                      // alt={g.image.fluid.mobile.alt}
                      media="(max-width: 400px)"
                    />
                    <source
                      srcSet={g.image.thumbnails.Tablet.url}
                      // alt={g.image.fluid.tablet.alt}
                      media="(max-width: 900px)"
                    />
                    <img 
                    src={g.image.thumbnails.Desktop.url}
                    // alt={g.image.fluid.desktop.alt}
                     />
                  </picture>
                   {/* <img
                    src={g.image.fluid.srcSet}
                    // alt={article.node.data.article_image.alt}
                    // title={article.node.data.article_image.alt}
                    // sx={{
                    //   height: '100%',
                    //   borderTopLeftRadius: '25px',
                    //   borderTopRightRadius: '25px'
                    // }}
                  /> */}

                  {g.caption.text} 
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default GallerySlider
